import { OneSignalProvider } from './providers/OneSignalProvider';
import { AudioProvider } from './contexts/AudioContext';
import { AppInner } from './components/AppInner';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
// 🛡️ FIX: useAutoPreloader REMOVED from top-level App
// It was causing setState during hydration via fetch callbacks
// Now moved to ClientOnlyAuthSideEffects (post-hydration safe)
import { useIubenda } from './hooks/useIubenda';
import { BlogPost as BlogPostType } from './types/blog';

// Re-export SSRContext from the single source of truth
// entry-server-conditional.tsx imports from here
export type { SSRContext } from './types/ssr-context';
import type { SSRContext } from './types/ssr-context';

// Add optional SSR context prop
interface AppProps {
  ssrContext?: SSRContext;
}

function App({ ssrContext }: AppProps = {}) {
  // Initialize Google Analytics
  useGoogleAnalytics();

  // 🛡️ FIX: useAutoPreloader REMOVED - moved to ClientOnlyAuthSideEffects
  // This was causing setState during hydration window via fetch callbacks

  // Load Iubenda privacy scripts dynamically
  useIubenda();

  return (
    <OneSignalProvider>
      <AudioProvider>
        <AppInner ssrContext={ssrContext} />
      </AudioProvider>
    </OneSignalProvider>
  );
}

export default App;

// Export for SSR support
export const AppContent = App;

// Add global window interface to handle SSR hydration
declare global {
  interface Window {
    __BLOG_POSTS?: BlogPostType[];
  }
}
